import { api } from './api';

export function listFeedPosts({ limit = 20, cursor } = {}) {
  return api.get('/api/feed/posts', { params: { limit, cursor: cursor || undefined } });
}

export function createFeedPost(body) {
  return api.post('/api/feed/posts', body);
}

export function updateFeedPost(postId, body) {
  return api.put(`/api/feed/posts/${postId}`, body);
}

export function deleteFeedPost(postId) {
  return api.delete(`/api/feed/posts/${postId}`);
}

export function listPostComments(postId, { limit = 20, skip = 0 } = {}) {
  return api.get(`/api/feed/posts/${postId}/comments`, { params: { limit, skip } });
}

export function addPostComment(postId, body) {
  return api.post(`/api/feed/posts/${postId}/comments`, { body });
}

export function setPostReaction(postId, reactionType) {
  return api.post(`/api/feed/posts/${postId}/reactions`, { reaction_type: reactionType });
}

export function removePostReaction(postId, reactionType) {
  return api.delete(`/api/feed/posts/${postId}/reactions/${reactionType}`);
}

export function pinPost(postId, pin = true) {
  return api.post(`/api/feed/posts/${postId}/${pin ? 'pin' : 'unpin'}`);
}
